<template>
  <div class="editor-container">
    <div class="toolbar-block pt-2">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            class="mx-1"
            fab
            small
            @click="copyText"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>COPY</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            class="mx-1"
            fab
            small
            @click="pasteText"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-content-paste</v-icon>
          </v-btn>
        </template>
        <span>PASTE</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            class="mx-1"
            fab
            small
            @click="downloadTextFile"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
        </template>
        <span>IMPORT</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            class="mx-1"
            fab
            small
            @click="uploadTextFile"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-upload</v-icon>
          </v-btn>
        </template>
        <span>EXPORT</span>
      </v-tooltip>

      <input
        id="file-upload"
        type="file"
        style="display: none"
        @change="saveUploadTextFile"
      />
    </div>

    <v-textarea
      v-if="['IL', 'ST'].includes(this.pou.body.language)"
      @input="updatePouBody"
      class="editor__main"
      solo
      label="POU body"
      rows="10"
      :value="this.pou.body.data.text"
    ></v-textarea>
  </div>
</template>

<script>
import { find } from "lodash";

export default {
  name: "ILSTEditor",
  props: ["pouTempId"],
  data() {
    return {};
  },
  computed: {
    pou() {
      return find(this.$store.state.pous, { tempId: this.pouTempId });
    },
  },
  methods: {
    copyText() {
      navigator.clipboard.writeText(this.pou.body.data.text);
    },
    async pasteText() {
      this.updatePouBody(await navigator.clipboard.readText());
    },
    downloadTextFile() {
      const a = document.createElement("a");
      const blob = new Blob([this.pou.body.data.text]);
      a.href = URL.createObjectURL(blob);
      a.download = `${this.pou.name}.txt`;
      a.click();
    },
    uploadTextFile() {
      document.getElementById("file-upload").click();
    },
    saveUploadTextFile(event) {
      const [file] = event.target.files;
      if (file) {
        const reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = (evt) => {
          this.updatePouBody(evt.target.result);
        };
      }
    },
    updatePouBody(text) {
      this.$store.dispatch("updatePou", {
        ...this.pou,
        body: {
          ...this.pou.body,
          data: {
            text,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.editor-container {
  width: 100%;
}

.toolbar-block {
  background-color: #eee;
}
</style>
